let configurations = require('../configurations')
let cloudinarySettings = configurations.cloudinary_settings
let cloud_name = configurations.cloudinary_cloudName
let upload_preset = configurations.cloudinary_preset

export default {
  data() {
    return {
      screenH: 0,
      screenW: 0,
      flickrImageAvailability: false
    }
  },
  methods: {
    fullscreenImage(key, photoDetails) {
      // change these links in hello.js
      // as well, otherwise wrong url will be downloaded
      // as soon as data from api is fetched
      if (key != null) {
        if (key.match("^fse")) {
          let link = photoDetails.photoSourceLink
          let photoLink = link.replace("original", `height${this.screenH}`)
          return photoLink
        }
        else {
          if (!!photoDetails.flickrImageLink) {
            let flickrLink = this.getFlickrLinkFullScreen(photoDetails.flickrImageLink)
            if (this.flickrImageLinkAvailable(flickrLink)) {
              return flickrLink;
            } else {
              return `https://res.cloudinary.com/${cloud_name}/image/upload/h_${this.screenH},${cloudinarySettings}/${upload_preset}/${key}`
            }
          } else {
            if(photoDetails.uploader === "user"){
             
              return `https://res.cloudinary.com/${cloud_name}/image/upload/h_${this.screenH},${cloudinarySettings}/${upload_preset}/${key}`

            }
            else{
            return photoDetails.photoSourceLink
            }
          }
        }
      }
      else {
        return `https://res.cloudinary.com/${cloud_name}/image/upload/h_${this.screenH},${cloudinarySettings}/${upload_preset}/${key}`
      }
    },
    listviewImage(key, photoDetails) { // for image details page top image as well
      if (key != null) {
        if (key.match("^fse")) {
          let link = photoDetails.photoSourceLink
          let photoLink = link.replace("original", `width${this.screenW}`)
          return photoLink
        }
        else if (!!photoDetails.propertyLink) {
          if (photoDetails.photoSourceLink.includes("w=")) {
            let photoLink = new URL(photoDetails.photoSourceLink)
            let baseURL = photoLink.origin;
            let path = photoLink.pathname;
            photoLink.searchParams.set("w", this.screenW);
            let search = photoLink.search
            return baseURL + path + search;
          }
          return photoDetails.photoSourceLink;
        }
        else {
          if (!!photoDetails.flickrImageLink) {
            let flickrLink = this.getFlickrLink(photoDetails.flickrImageLink)
            if (this.flickrImageLinkAvailable(flickrLink)) {
              return flickrLink;
            } else {
              return photoDetails.photoSourceLink

            }
          } else {
            return photoDetails.photoSourceLink;
          }
        }
      }
      else {
        return photoDetails.photoSourceLink;
      }
    },
    nearbyViewzzzImage(key, photoDetails) {
      if (key != null) {
        if (key.match("^fse")) {
          let link = photoDetails.photoSourceLink
          let photoLink = link.replace("original", "259x392")
          return photoLink
        } else if (key.match("^slh") || key.match("^pg") || key.match("^vrbo") || key.match("^itc") || key.match("^ofs")) {
          if (photoDetails.photoSourceLink.includes("w=")) {
            let photoLink = new URL(photoDetails.photoSourceLink)
            let baseURL = photoLink.origin;
            let path = photoLink.pathname;
            photoLink.searchParams.set("w", 259);
            photoLink.searchParams.set("h", 400);
            let search = photoLink.search
            return baseURL + path + search;
          }
          return photoDetails.photoSourceLink;
        }
        else {
          if (!!photoDetails.flickrImageLink) {
            if (this.flickrImageLinkAvailable(photoDetails.flickrImageLink.replace("_o.", "_c."))) {
              return photoDetails.flickrImageLink.replace("_o.", "_c.")
            } else {
              return `https://res.cloudinary.com/${cloud_name}/image/upload/h_392,w_259,c_fill,${cloudinarySettings}/${upload_preset}/${key}`
            }
          } else {
            return `https://res.cloudinary.com/${cloud_name}/image/upload/h_392,w_259,c_fill,${cloudinarySettings}/${upload_preset}/${key}`
          }
        }
      }
    },
    profileFallBackImage() {
      return `https://res.cloudinary.com/${cloud_name}/image/upload/w_${this.screenW},${cloudinarySettings}/${upload_preset}/IMG_9689_fkookv_aywwr4`
    },
    mapViewImage(key, photoDetails) {
      if (key.match("^fse")) {
        let link = photoDetails.photoSourceLink
        let photoLink = link.replace("original", "500x500")
        return photoLink
      }
      else {
        if (!!photoDetails.flickrImageLink) {
          if (this.flickrImageLinkAvailable(photoDetails.flickrImageLink.replace("_o.", "_c."))) {
            return photoDetails.flickrImageLink.replace("_o.", "_c.")
          } else {
            return `https://res.cloudinary.com/${cloud_name}/image/upload/h_500,w_500,c_fill,${cloudinarySettings}/${upload_preset}/${key}`
          }
        } else {
            if(photoDetails.photoSourceLink !== ""){
              return photoDetails.photoSourceLink
            }
            else{
              return `https://res.cloudinary.com/${cloud_name}/image/upload/h_500,w_500,c_fill,${cloudinarySettings}/${upload_preset}/${key}`
            }
        }
      }
    },
    profileLinksImage(key) {
      return `https://res.cloudinary.com/${cloud_name}/image/upload/w_600,h_900,c_fill,${cloudinarySettings}/${upload_preset}/${key}`
    },
    passcodeImage() {
      return `https://res.cloudinary.com/${cloud_name}/image/upload/w_600,h_900,c_fill,${cloudinarySettings},e_blur:400/${upload_preset}/awmu8hhyxzzr9cunn3j5`
    },
    blurImage(key, photoSourceLink) {
      if (key.match("^fse")) {
        let link = photoSourceLink
        let photoLink = link.replace("original", "900x600")
        return photoLink
      }
      else {
        return `https://res.cloudinary.com/${cloud_name}/image/upload/w_600,h_900,c_fill,${cloudinarySettings}/${upload_preset}/${key}`
      }
    },
    filterImage(key) {
      return `https://res.cloudinary.com/${cloud_name}/image/upload/h_200,c_fill,${cloudinarySettings}/${upload_preset}/${key}`
    },
    getFlickrLink(photoLink) {
      if (this.screenW > 1200 && this.screenW < 1600) {
        return photoLink.replace("_o.", "_h.")
      } else if (this.screenW > 1600) {
        return photoLink.replace("_o.", "_k.")
      } else if (this.screenW < 1200 && this.screenW > 800) {
        return photoLink.replace("_o.", "_b.")
      } else if (this.screenW <= 800) {
        return photoLink.replace("_o.", "_c.")
      }
    },
    getFlickrLinkFullScreen(photoLink) {
      if (this.screenH > 1200 && this.screenH < 1600) {
        return photoLink.replace("_o.", "_h.")
      } else if (this.screenH > 1600) {
        return photoLink.replace("_o.", "_k.")
      } else if (this.screenH < 1200) {
        return photoLink.replace("_o.", "_k.")
      }
    },
    async flickrImageLinkAvailable(photoLink) {
      this.flickrImageAvailability = false;
      await fetch(photoLink).then(
        response => {
          if (response.status < 400) {
            this.flickrImageAvailability = true;
          } else if (response.status === 403) {
            this.flickrImageAvailability = false;
          } else if (response.status === 404) {
            this.flickrImageAvailability = false;
          };
        }
      )
      return this.flickrImageAvailability;
    }
  },

  created() {
    this.screenH = screen.height
    this.screenW = screen.width
  }
}



// WEBPACK FOOTER //
// ./src/mixin/imageLinks.js